import { getReviews, setReviews } from 'Store/Reviews/Reviews.action';
import { fetchQuery } from 'Util/Request';
import { showNotification } from 'Store/Notification/Notification.action';
import ReviewsQuery from 'Query/Reviews.query';

export class ReviewsDispatcher {
    requestReviews(dispatch, id, page, details) {
        const query = ReviewsQuery.getReviewsListQuery(id, page, details);

        return fetchQuery(query).then(
            ({ products: { items: [reviewsList] } }) => dispatch(getReviews(reviewsList)),
            (error) => {
                dispatch(showNotification('error', error[0].message));
            }
        );
    }

    requestCustomerReviews(dispatch, email) {
        const query = ReviewsQuery.getCustomerReviewsQuery(email);

        return fetchQuery(query).then(
            ({ reviewsCustomer: { reviews } }) => dispatch(setReviews(reviews, true)),
            (error) => {
                dispatch(showNotification('error', error[0].message));
            }
        );
    }
}

export default new ReviewsDispatcher();
